import { render, staticRenderFns } from "./ResumeCashWithheld.vue?vue&type=template&id=a47f107c&scoped=true&"
import script from "./ResumeCashWithheld.vue?vue&type=script&lang=ts&"
export * from "./ResumeCashWithheld.vue?vue&type=script&lang=ts&"
import style0 from "./ResumeCashWithheld.vue?vue&type=style&index=0&id=a47f107c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a47f107c",
  null
  
)

export default component.exports